export const LINKS = {
  home: {
    name: "Home",
    path: "/",
  },
  about: {
    name: "About",
    path: "/about-us",
  },
  services: {
    name: "Services",
    path: "#",
    children: [
      {
        name: "cybersecurity",
        path: "/cybersecurity",
        children: [
          {
            name: "Managed Security",
            path: "/cybersecurity/managed-security",
          },
          {
            name: "Security Testing",
            path: "/cybersecurity/security-testing",
          },
          {
            name: "SAP Security",
            path: "/cybersecurity/sap-security",
          },
          {
            name: "ICS or SCADA Security Consulting",
            path: "/cybersecurity/ics-scada-security-consulting",
          },
          {
            name: "Data Leakage Protection (DLP) Services",
            path: "/cybersecurity/dlp-services",
          },
          {
            name: "Data Classification Solutions",
            path: "/cybersecurity/data-classification-solutions",
          },
          {
            name: "Mobile Security MDM Solutions",
            path: "/cybersecurity/mobile-security-mdm-solutions",
          },
          {
            name: "Network Security",
            path: "/cybersecurity/network-security",
          },
          {
            name: "Identity and Access Management",
            path: "/cybersecurity/incident-access-management",
          },
        ],
      },
      {
        name: "Consulting",
        path: "/consulting",
        children: [
          {
            name: "Oil and Gas",
            path: "/consulting/oil-and-gas",
          },
          {
            name: "Supply Chain",
            path: "/consulting/supply-chain",
          },
        ],
      },
      {
        name: "IT Consulting",
        path: "#",
        children: [
          {
            name: "IT Strategy",
            path: "/it-consulting/it-strategy",
          },
          {
            name: "IT Infrastructure",
            path: "/it-consulting/it-infrastructure",
          },
          {
            name: "Security Awareness",
            path: "/it-consulting/security-awareness",
          },
        ],
      },
      {
        name: "cybersecurity awareness",
        path: "/cybersecurity-awareness",
      },
      {
        name: "cybersecurity events",
        path: "/cybersecurity-events",
      },
      {
        name: "ot security",
        path: "/ot-security",
      },
      {
        name: "Socaas",
        path: "/socaas",
      },
    ],
  },
  career: {
    name: "Career",
    path: "/career",
  },
  contact: {
    name: "Contact",
    path: "/contact",
  },
}
